import React, { useEffect, useState, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import styles from "./eventCalendar.module.css";
import { useLocation,useNavigate  } from "react-router-dom";
import EventDetail from "./EventDetail";
import EventDetail2 from "./EventDetail2";

function renderDayCellContent(eventInfo) {
  return (
    <div>
      <div
        className={
          eventInfo.dow === 0
            ? `${styles.textRed}`
            : eventInfo.dow === 6
            ? `${styles.textBlue}`
            : ""
        }
      >
        {eventInfo.dayNumberText}
      </div>
    </div>
  );
}

function renderEventContent(eventInfo) {
  return (
    <div className={`${styles.renderEventContentContainer} `}>
      <div className={`${styles.renderEventContentTitle}`}>
        {eventInfo.event.title}
      </div>
    </div>
  );
}
//http://localhost:3000/event?boardID=2096
export default function EventCalendar2() {
  const [events, setEvents] = useState([]);
  const [view, setView] = useState(false);
  const [detail, setDetail] = useState({}); // 상세 데이터를 담을 상태
  const location = useLocation();
  const navigate = useNavigate(); // useNavigate 훅 추가
  const queryParams = new URLSearchParams(location.search);
  const boardID = queryParams.get("boardID"); // 'siteNo' 쿼리 파라미터의 값을 가져옵니다.
  const articleID =
    queryParams.get("ArticleID") || queryParams.get("articleID"); // 대소문자 모두 체크
  const [isLoading, setIsLoading] = useState(true); // 로딩 상태 추가
  const defaultLanguage = queryParams.get("default") || "ko";

  const myDivRef = useRef(null);

  const handleDateChange = async (view) => {
    const startDate = new Date(view.start);
    startDate.setMonth(startDate.getMonth() + 1);

    const startDateISO = startDate.toISOString();
    const yearMonth =
      startDateISO.substring(0, 4) + startDateISO.substring(5, 7);

    await fetchBoardData(yearMonth);
  };

  //이벤트 클릭시 샘플로 게시글상세로 페이지 이동
  const handleEventClick = (clickEventInfo) => {
    // const boardID = clickEventInfo.event._def.extendedProps.BoardID;
    // const articleID = clickEventInfo.event._def.extendedProps.articleID;

    setDetail(clickEventInfo.event._def.extendedProps);
    setView(true);
    scrollToTop();
  };

  const handleCalendarMove = () => {
    setView(false);

    const targetBoardID = boardID ;
    navigate(`/event?boardID=${targetBoardID}`);
  };

  const fetchArticleData = async (boardID, articleID) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `https://b2capi.tripbox.co.kr/Site/GetArticle?ArticleID=${articleID}`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      const dataInfo = {
        title: data.Title,
        start: data.start,
        end: data.end,
        BoardID: data.BoardID,
        articleID: data.ArticleID,
        WriterName: data.WriterName,
        ContentHtml: data.ContentHtml,
      };
      setDetail(dataInfo);
      setView(true);
    } catch (error) {
      console.error("Fetching article data failed:", error);
      setDetail(null);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchBoardData = async (yearMonth = "202311") => {
    setIsLoading(true);
    const colors = [
      "#D50000",
      "#F4511E",
      "#33B679",
      "#039BE5",
      "#7986CB",
      "#616161",
      "#E67C73",
      "#F6BF26",
      "#0B8043",
      "#3F51B5",
      "#8E24AA",
      "#7CB342",
    ];

    try {
      const response = await fetch(
        `https://b2capi.tripbox.co.kr/Site/GetBoardAllArticles?BoardID=${boardID}&YYYYMM=${yearMonth}`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      // console.log("data", data);

      setEvents(
        data.map((item) => {
          const randomColor = colors[Math.floor(Math.random() * colors.length)];
          return {
            title: item.Title,
            start: item.start,
            end: item.end,
            backgroundColor: randomColor,
            borderColor: randomColor,
            BoardID: item.BoardID,
            articleID: item.ArticleID,
            WriterName: item.WriterName,
            ContentHtml: item.ContentHtml,
          };
        })
      );

      window.dispatchEvent(new Event("resize"));
    } catch (error) {
      console.error("Fetching data failed:", error);
      setEvents([]);
    } finally {
      setIsLoading(false);
    }
  };

  const scrollToTop = () => {
    if (myDivRef.current) {
      myDivRef.current.scrollTop = 0;
    }
  };

  useEffect(() => {
    if (boardID && articleID) {
      fetchArticleData(boardID, articleID);
    } else {
      const initializeBoardData = async () => {
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() + 1);
        const startDateISO = startDate.toISOString();
        const yearMonth =
          startDateISO.substring(0, 4) + startDateISO.substring(5, 7);

        await fetchBoardData(yearMonth);
      };

      initializeBoardData();
    }
  }, [boardID, articleID]);

  return (
    <>
      {/* <div className={`w-full  ${view ? "" : "h-screen"}  flex flex-col `}>
        <div className={`flex-grow p-[1rem] ${view ? "hidden  " : "h-full"}`}>
          <FullCalendar
            plugins={[dayGridPlugin]}
            weekends={true}
            locale={defaultLanguage}
            expandRows={true}
            height="100%"
            datesSet={(view) => {
              handleDateChange(view);
            }}
            selectable={false}
            editable={false}
            events={events}
            eventClick={handleEventClick}
            eventContent={renderEventContent}
            dayCellContent={renderDayCellContent}
            eventLongPressDelay={100}
          />
        </div>
      </div> */}

      {view && (
        <div className={`flex-grow ${view ? "" : "hidden"}`} ref={myDivRef}>
          <EventDetail2
            item={detail}
            handleCalendarMove={handleCalendarMove}
            defaultLanguage={defaultLanguage}
          />
        </div>
      )}
    </>
  );
}
